module.exports = __webpack_public_path__ + "510dec37fa69fba39593e01a469ee018.woff2";